import React from 'react';

const About = () => {
  return (
    <>
      <style>{aboutStyles}</style>

      <div className="ab-root">



        <div className="ab-rule-wrap"><hr className="ab-hr" /></div>

        {/* ── HERO STATEMENT ── */}
        <div className="ab-hero">
          <span className="ab-hero-eyebrow">Est. 2024</span>

                  <div className="ab-rule-wrap"><hr className="ab-hr" /></div>

                  {/* ── LOGO ── */}
        <div className="ab-logo-wrap">
          <img
            src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/VESHH-EON_TYPE_WEB_ppfyxy.png"
            alt="VESHH-EON"
            className="ab-logo"
          />
        </div>




          
          <h1 className="ab-hero-line">
            {/* We don't follow<br />
            <span className="ab-hero-bold">trends.</span> */}
            <img src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/Walk_like_you_own_the_damn_street_Black_mywnyq.png" />
          </h1>
          {/* <h1 className="ab-hero-line ab-hero-line--ghost">
            We <span className="ab-hero-bold">create</span> them.
          </h1> */}
        </div>

        <div className="ab-rule-wrap"><hr className="ab-hr" /></div>

        {/* ── SECTIONS ── */}
        <div className="ab-sections">

          {/* 01 — Philosophy */}
          <section className="ab-section">
            <div className="ab-section-meta">
              <span className="ab-section-num">01</span>
              <div className="ab-section-heading">
                <span className="ab-eyebrow">Brand</span>
                <h2 className="ab-title">The <span className="ab-title-bold">Philosophy</span></h2>
              </div>
            </div>
            <div className="ab-section-body">
              <p className="ab-pull">
                "Clothing is never just fabric — it's the armor you wear into your ambitions."
              </p>
              <p className="ab-text">
                VESHH-EON exists in the space between what is and what could be. Every thread we weave carries intention. Every silhouette we craft honors the audacity to be unapologetically yourself.
              </p>
              <p className="ab-text">
                In a world obsessed with the temporary, we choose the eternal. While others chase fleeting moments, we build legacies that transcend seasons, cultures, and time itself.
              </p>
            </div>
          </section>

          <div className="ab-rule-wrap ab-rule-wrap--section"><hr className="ab-hr" /></div>

          {/* 02 — Genesis */}
          <section className="ab-section">
            <div className="ab-section-meta">
              <span className="ab-section-num">02</span>
              <div className="ab-section-heading">
                <span className="ab-eyebrow">Origin</span>
                <h2 className="ab-title">The <span className="ab-title-bold">Genesis</span></h2>
              </div>
            </div>
            <div className="ab-section-body">
              <p className="ab-pull">
                "Born not as a brand, but as a rebellion against mediocrity."
              </p>
              <p className="ab-text">
                It began with a question whispered in a crowded room: <em>What if fashion could make you feel invincible?</em>
              </p>
              <p className="ab-text">
                We saw a generation hungry for authenticity in an age of imitation, yearning for pieces that would grow with them, evolve with them, become part of their story. Our founders didn't want to dress bodies. They wanted to dress dreams.
              </p>
              <p className="ab-text">
                From late-night sketches in cramped studios to the moment our first piece touched skin — every step was guided by one unwavering truth: the right garment doesn't just fit your form. It fits your future.
              </p>
            </div>
          </section>

          <div className="ab-rule-wrap ab-rule-wrap--section"><hr className="ab-hr" /></div>

          {/* 03 — Vision */}
          <section className="ab-section">
            <div className="ab-section-meta">
              <span className="ab-section-num">03</span>
              <div className="ab-section-heading">
                <span className="ab-eyebrow">Future</span>
                <h2 className="ab-title">The <span className="ab-title-bold">Vision</span></h2>
              </div>
            </div>
            <div className="ab-section-body">
              <p className="ab-pull">
                "We are architecting a new cultural language."
              </p>
              <p className="ab-text">
                VESHH-EON is where visionaries find their uniform, where creators discover their second skin, where the bold recognize their tribe. We envision a world where personal style becomes personal power.
              </p>
              <p className="ab-text">
                This is not about following — it's about leading. Not about fitting in — it's about standing out while standing together. We are curating a community of the creatively restless, the beautifully ambitious, the quietly revolutionary.
              </p>
              <p className="ab-text">
                Join us, and become part of something that history will remember.
              </p>
            </div>
          </section>

          <div className="ab-rule-wrap ab-rule-wrap--section"><hr className="ab-hr" /></div>

          {/* 04 — The Founder */}
          <section className="ab-section">
            <div className="ab-section-meta">
              <span className="ab-section-num">04</span>
              <div className="ab-section-heading">
                <span className="ab-eyebrow">Founder</span>
                <h2 className="ab-title">The <span className="ab-title-bold">Person</span></h2>
              </div>
            </div>
            <div className="ab-section-body">
              <p className="ab-pull">
                "Built by one. Meant for a billion."
              </p>
              <p className="ab-text">
                VESHH-EON was founded by <strong>Vighnesh Shetty</strong> — a creator, musician, designer, and entrepreneur driven by a passion for building meaningful things from the ground up. Throughout his journey, he was inspired by the countless individuals who dedicate themselves to pursuing their dreams — whether in art, business, sports, technology, or any other field.
              </p>
              <p className="ab-text">
                This vision led to the creation of VESHH-EON, a brand built on the belief that clothing can be more than just fashion — it can represent ambition, identity, and purpose. The name combines "Veshh," inspired by the Sanskrit concept of attire and self-expression, with "Eon," symbolizing a billion aspirations. Together, VESHH-EON stands for a billion dreams and the relentless pursuit of turning them into reality.
              </p>
              <p className="ab-text">
                More than a clothing label, VESHH-EON reflects the mindset of dreamers, creators, and innovators who refuse to settle for ordinary. Through the brand, Vighnesh aims to inspire people to embrace their individuality, wear their aspirations with confidence, and keep moving forward toward the life they envision.
              </p>
            </div>
          </section>

        </div>

        {/* ── CLOSING ── */}
        <div className="ab-rule-wrap"><hr className="ab-hr" /></div>
        <div className="ab-closing">
          <span className="ab-closing-sub">Where vision becomes reality</span>
          {/* <h3 className="ab-closing-mark">VESHH-EON</h3> */}
          <div className="ab-logo-wrap">
          <img
            src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/VESHH-EON_TYPE_WEB_ppfyxy.png"
            alt="VESHH-EON"
            className="ab-logo"
          />
        </div>
        </div>

      </div>
    </>
  );
};

const aboutStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Exo+2:ital,wght@0,200;0,300;0,400;0,500;0,600;1,300&display=swap');

  .ab-root {
    background: white;
    min-height: 100vh;
    font-family: 'Exo 2', sans-serif;
    padding-bottom: 96px;
  }

  /* ── LOGO ── */
  .ab-logo-wrap {
    display: flex;
    justify-content: center;
    padding: 56px 24px 40px;
  }
  .ab-logo {
    height: 100px;
    width: auto;
    /* invert so logo shows on light bg — remove if logo is already dark */
    // filter: invert(1);
  }

  /* ── RULES ── */
  .ab-rule-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 80px;
  }
  .ab-rule-wrap--section {
    padding-top: 0;
  }
  .ab-hr {
    border: none;
    border-top: 1px solid black;
    margin: 0;
  }

  /* ── HERO ── */
  .ab-hero {
    max-width: 1200px;
    margin: 0 auto;
    padding: 72px 80px 64px;
  }

  .ab-hero-eyebrow {
    display: block;
    font-size: 9px;
    font-weight: 400;
    letter-spacing: 0.5em;
    text-transform: uppercase;
    color: black;
    margin-bottom: 28px;
  }

  .ab-hero-line {
    font-size: clamp(48px, 7vw, 96px);
    font-weight: 200;
    color: #000;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    line-height: 0.95;
    margin: 0 0 8px;
  }

  .ab-hero-line--ghost {
    color: black;
  }

  .ab-hero-bold {
    font-weight: 600;
  }

  /* ── SECTIONS ── */
  .ab-sections {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 80px;
  }

  .ab-section {
    display: grid;
    grid-template-columns: 280px 1fr;
    gap: 60px;
    padding: 64px 0;
  }

  /* Left meta column */
  .ab-section-meta {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .ab-section-num {
    font-size: 72px;
    font-weight: 200;
    color: black;
    line-height: 1;
    letter-spacing: -0.02em;
    display: block;
  }

  .ab-eyebrow {
    display: block;
    font-size: 8px;
    font-weight: 400;
    letter-spacing: 0.45em;
    text-transform: uppercase;
    color: black;
    margin-bottom: 10px;
  }

  .ab-title {
    font-size: clamp(24px, 3vw, 36px);
    font-weight: 200;
    color: #000;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    line-height: 1;
    margin: 0;
  }
  .ab-title-bold { font-weight: 600; }

  /* Right body column */
  .ab-section-body {
    padding-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .ab-pull {
    font-size: clamp(16px, 2vw, 22px);
    font-weight: 300;
    font-style: italic;
    color: black;
    line-height: 1.6;
    letter-spacing: 0.02em;
    border-left: 2px solid black;
    padding-left: 20px;
    margin-bottom: 4px;
  }

.ab-text {
  font-size: 14px;
  font-weight: 300;
  color: black;
  line-height: 2;
  letter-spacing: 0.04em;
  text-align: justify;
}

  /* ── CLOSING ── */
  .ab-closing {
    max-width: 1200px;
    margin: 0 auto;
    padding: 72px 80px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;
  }

  .ab-closing-sub {
    font-size: 9px;
    font-weight: 400;
    letter-spacing: 0.5em;
    text-transform: uppercase;
    color: black;
  }

  .ab-closing-mark {
    font-size: clamp(36px, 6vw, 80px);
    font-weight: 600;
    color: #000;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    margin: 0;
    line-height: 1;
  }

  /* ── RESPONSIVE ── */
  @media (max-width: 1024px) {
    .ab-hero     { padding: 56px 40px 48px; }
    .ab-rule-wrap { padding: 0 40px; }
    .ab-sections  { padding: 0 40px; }
    .ab-closing   { padding: 56px 40px 0; }
    .ab-section   { grid-template-columns: 200px 1fr; gap: 40px; }
  }

  @media (max-width: 768px) {
    .ab-hero      { padding: 40px 20px 36px; }
    .ab-rule-wrap { padding: 0 20px; }
    .ab-sections  { padding: 0 20px; }
    .ab-closing   { padding: 48px 20px 0; }

    .ab-section {
      grid-template-columns: 1fr;
      gap: 24px;
      padding: 48px 0;
    }

    .ab-section-meta {
      flex-direction: row;
      align-items: flex-end;
      gap: 16px;
    }

    .ab-section-num {
      font-size: 48px;
      line-height: 1;
    }

    .ab-logo { height: 36px; }
    .ab-logo-wrap { padding: 40px 20px 28px; }
  }

  @media (max-width: 360px) {
    .ab-hero     { padding: 32px 14px 28px; }
    .ab-sections { padding: 0 14px; }
    .ab-rule-wrap { padding: 0 14px; }
    .ab-closing  { padding: 40px 14px 0; }
  }
`;

export default About;
